// Meta tags configuration for SEO and PWA
export const PRODUCTION_URL = 'https://mobile.sclepios-ia.com';

export const seoMeta = {
  productionUrl: PRODUCTION_URL,
  title: 'Sclepios IA — Assistant médical IA pour soignants',
  description: 'Chat médical IA, 67+ calculateurs de scores, flashcards, quiz et cas cliniques. Aide à la décision pour soignants. Essai gratuit 7 jours.',
  
  // Open Graph
  ogTitle: 'Sclepios IA — Assistant médical IA pour soignants',
  ogDescription: 'Chat médical IA, 67+ calculateurs de scores, flashcards, quiz et cas cliniques. Essai gratuit 7 jours.',
  ogType: 'website',
  ogImage: `${PRODUCTION_URL}/lovable-uploads/85ddc4ea-d7a0-466b-a9eb-5204c3b57a84.png`,
  ogSiteName: 'Sclepios IA',
  
  // Twitter
  twitterCard: 'summary_large_image',
  twitterTitle: 'Sclepios IA — Assistant médical IA pour soignants',
  twitterDescription: 'Chat médical IA, 67+ calculateurs de scores, flashcards, quiz et cas cliniques. Essai gratuit.',
  twitterImage: `${PRODUCTION_URL}/lovable-uploads/85ddc4ea-d7a0-466b-a9eb-5204c3b57a84.png`,
  
  // PWA
  themeColor: '#0ea5e9',
  backgroundColor: '#ffffff',
  viewport: 'width=device-width, initial-scale=1.0, viewport-fit=cover',

  // E-E-A-T — Founder
  founder: {
    name: 'Dr Andréï Galindo',
    jobTitle: 'Médecin urgentiste',
    affiliation: 'Centre Hospitalier du Cateau-Cambrésis',
    linkedIn: 'https://linkedin.com/in/andrei-galindo',
    photo: 'https://andreigalindo.sclepios-ia.com/assets/dr-galindo-photo-800-CL9eCQ0C.jpg',
  },
};
